import { ReactNode } from 'react';

import { mergeClasses } from '@/utils';

import { Badge } from '@/components/common';

interface IconBadge {
  icon: ReactNode;
  data: string;
  className?: string;
  isLight: boolean;
  variant?:
    | 'primary'
    | 'red'
    | 'orange'
    | 'yellow'
    | 'lime'
    | 'green'
    | 'teal'
    | 'cyan'
    | 'blue'
    | 'indigo'
    | 'violet'
    | 'grape'
    | 'pink';
}

export const IconBadge = ({ icon, data, className, isLight, variant }: IconBadge) => {
  return (
    <div className={mergeClasses('flex items-center justify-center relative', className)}>
      {icon}
      <Badge
        className="absolute -top-1.5 right-3 border-[2px] border-neutral-0 !text-semibold !text-body-xs !p-0 !m-0"
        variant={variant}
        size="sm"
        mode={isLight ? 'light' : 'normal'}
      >
        {data}
      </Badge>
    </div>
  );
};
